import { client, DEFAULT_HEADERS } from "./defaultClient";
import {
    Memory,
    PostMemoryCommentImagesSignedurl200ResponseInner,
} from "./generated";

export const getMemories = async (
    nextPageToken: string | undefined,
    limit: number
): Promise<{
    memories: Memory[];
    hasNextPage: boolean;
    nextPageToken: string | undefined;
}> => {
    const response = await client.getMemories(
        { nextPageToken, limit },
        { mode: "cors" }
    );
    return {
        memories: response.memories,
        hasNextPage: response.hasNextMemory,
        nextPageToken: response.nextPageToken,
    };
};

export const getFavoriteMemories = async (): Promise<Memory[]> => {
    return await client.getMemoriesFavorites({ mode: "cors" });
};

export const addCommentOnMemory = async (
    memoryId: string,
    text: string,
    imagePaths: Array<string>,
    csrfToken: string
): Promise<Memory> =>
    await client.postMemoryMemoryIdComments(
        { memoryId, newComment: { text, imagePaths } },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );

export const getMemory = async (memoryId: string): Promise<Memory> =>
    await client.getMemoryMemoryId({ memoryId }, { mode: "cors" });

export const incrementMemoryLikedCount = async (
    memoryId: string,
    csrfToken: string
): Promise<Memory> =>
    await client.patchMemoryMemoryIdLikedCount(
        { memoryId },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );

export const addMemoryFavorite = async (
    memoryId: string,
    csrfToken: string
): Promise<void> =>
    await client.postMemoryMemoryIdFavorite(
        { memoryId },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );

export const removeMemoryFavorite = async (
    memoryId: string,
    csrfToken: string
): Promise<void> => {
    await client.deleteMemoryMemoryIdFavorite(
        { memoryId },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
};

export const getSignedUrlForCommentImages = async (
    files: File[],
    csrfToken: string
): Promise<PostMemoryCommentImagesSignedurl200ResponseInner[]> => {
    const fileInfos = files.map((file) => {
        return {
            fileName: file.name,
            fileExtension: file.type.split("/")[1] ?? "",
            contentType: file.type,
        };
    });

    const response = await client.postMemoryCommentImagesSignedurl(
        {
            postMemoryCommentImagesSignedurlRequest: { fileInfos },
        },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
    return response;
};
